import { Route, Switch } from "react-router-dom/cjs/react-router-dom.min";
import React from "react";
import UpdatesfreightRates from '../updateFreightRates/Updatesfreightrates'
import Updatefreightexporter from "../updateFreightRates/Updatefreightexporter";
import UpdatefreightrateDetails from "../updateFreightRates/UpdatefreightrateDetails";
import UpdatefreightratList from "./UpdatefreightrateList"
import UpdateAllfreightrates from "../updateFreightRates/UpdateAllfreightrates"








const App = ({ match }) => (
    <Switch>
      <Route  path={`${match.url}/update-freight-rate`} component={UpdatesfreightRates} />
      <Route exact path={`${match.url}/freight-market-watch`} component={Updatefreightexporter} />
      <Route path={`${match.url}/freight-market-watch-Details`} component={UpdatefreightrateDetails} />
      <Route exact path={`${match.url}/freight-market-rate-List`} component={UpdatefreightratList} />
      <Route path={`${match.url}/freight-market-watch-all-details/all-quotes`} component={UpdateAllfreightrates}/>
    </Switch>
  );
  
  export default App;